

























import { Component, Watch } from "vue-property-decorator";
import CHeader from "@/components/CHeader.vue";
import CFooter from "@/components/CFooter.vue";
import RTab from "@/components/RTab.vue";
import OrderHistoryList from "@/components/OrderHistoryList.vue";
import CheckRestaurantLogin from "@/utils/CheckRestaurantLogin";
import AuthModule from "@/store/auth";
import OrderModule from "@/store/order";
import { RestaurantsApi } from "@/services/api-service";
import moment from "moment";
import { ja } from "vuejs-datepicker/dist/locale";
import PaginationModule from "@/store/pagination";
import { SortDirection } from "../api";

@Component({
  components: {
    CHeader,
    CFooter,
    RTab,
    OrderHistoryList,
  },
})
export default class ROrdersHistory extends CheckRestaurantLogin {
  private get me() {
    return AuthModule.me;
  }

  private get ja() {
    return ja;
  }

  private currentDate: Date | null = null;

  private dateFormatter(date: Date) {
    return moment(date).format("YYYY年MM月DD日");
  }

  private mounted() {
    this.getOrders();
    OrderModule.commitOrders([]);
  }

  @Watch("me")
  @Watch("$route", { deep: true })
  private async getOrders() {
    const limit = 8;
    const pageNum = this.$route.params?.pageNum ? Number(this.$route.params.pageNum) : 0;
    if (!this.me?.uuid || typeof this.me?.uuid !== "string") {
      return;
    }
    try {
      // eslint-disable-next-line prettier/prettier
      const ordersRes = await RestaurantsApi.instance.getOrdersByRestaurantUuid(
        this.me?.uuid,
        limit,
        pageNum === 0 ? 0 : (pageNum - 1) * limit,
        SortDirection.Desc,
        "deliveryDate",
        this.currentDate ? this.currentDate.toISOString() : undefined
      );
      // eslint-disable-next-line prettier/prettier
      if (!ordersRes.data.data?.items || !(ordersRes.data.data.items.length > 0)) {
        return;
      }

      OrderModule.commitOrders(ordersRes.data.data.items);
      PaginationModule.commitTotal(Number(ordersRes.data.data.total));
      PaginationModule.commitLimit(limit);
    } catch (err) {
      console.log(err);
    }
  }

  @Watch("currentDate")
  private setDate() {
    OrderModule.commitOrders([]);
    this.getOrders();
  }
}
